import { ICoordinates } from "../interfaces";

/**
 * Calcula a caixa delimitadora (bounding box) para um conjunto de coordenadas.
 * Retorna um objeto com as coordenadas máximas e mínimas que formam um retângulo
 * que contém todos os pontos fornecidos.
 * @param coords Array de coordenadas com latitude e longitude
 * @returns Objeto com as coordenadas top, bottom, left e right que definem a caixa
 */
export const getBoundingBox = (coords: ICoordinates[]) => {
    const lats = coords.map(c => c.lat);
    const lngs = coords.map(c => c.lng);
    return { top: Math.max(...lats), bottom: Math.min(...lats), left: Math.min(...lngs), right: Math.max(...lngs) };
};
